(() => {
  'use strict';

  if (window.PWCartSummaryDefaultLoaded) return;
  window.PWCartSummaryDefaultLoaded = true;

  let editing = false;
  let timer = null;

  const rootPath = () => (
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/'
  );

  const showSummary = () => {
    if (editing) return;

    const cart = document.querySelector('.cc-main-cart');
    if (!cart) return;

    const options = cart.querySelector('[data-pw-cart-step="options"]');
    const summary = cart.querySelector('[data-pw-cart-step="summary"]');
    if (!summary) return;

    if (options) options.hidden = true;
    summary.hidden = false;
  };

  const ensureDrawerLink = () => {
    document.querySelectorAll('cart-drawer').forEach((drawer) => {
      const serviceChoices = drawer.querySelector('[data-pw-cart-services][data-pw-cart-context="drawer"]');
      if (serviceChoices) serviceChoices.hidden = true;

      const actions = drawer.querySelector('.cart-drawer__checkout-buttons');
      if (!actions || actions.querySelector('a.btn')) return;

      const link = document.createElement('a');
      link.className = 'btn btn--primary w-full pw-cart-summary-link';
      link.href = `${rootPath()}cart`;
      link.textContent = 'Bekijk winkelwagen';
      actions.appendChild(link);
    });
  };

  const schedule = (delay = 0) => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      showSummary();
      ensureDrawerLink();
    }, delay);
  };

  window.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    if (target.closest('[data-pw-edit-options]')) {
      editing = true;
      return;
    }

    if (target.closest('[data-pw-confirm-options]')) {
      editing = false;
      schedule(120);
    }
  }, true);

  document.addEventListener('on:cart:change', () => schedule(100));
  document.addEventListener('dispatch:cart-drawer:open', () => schedule(30));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => schedule(0), { once: true });
  } else {
    schedule(0);
  }

  new MutationObserver(() => {
    if (!editing) schedule(40);
    else ensureDrawerLink();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
